import type { ErrorService } from "draivn-ui-domain";
import type { InjectionKey } from "vue";

export const ERROR_SERVICE_INJECTION_KEY: InjectionKey<ErrorService> =
  Symbol("ERROR_SERVICE");
